import type { FacilitatorSprintCallCard } from '../../../../../../pure-js/types/FacilitatorLiveSessionMonitor'
import { useFacilitatorSprintCallLink } from '../../../../apiLayer/queryHooks/mutations'
import { useOpenCallInNewTab } from './useOpenCallInNewTab'

/** Opens the call a whole sprint shares in a new tab. */
export const useJoinSprintCall = () => {
  const callLink = useFacilitatorSprintCallLink()
  const callTab = useOpenCallInNewTab()

  const join = (sprintCall: FacilitatorSprintCallCard) => {
    const request = { sprintId: sprintCall.sprintId, activityId: sprintCall.activityId }
    callTab.openWhenLinked((callbacks) => callLink.mutate(request, callbacks))
  }

  return { join, isOpening: callLink.isPending, outcome: callTab.outcome, clearOutcome: callTab.clearOutcome }
}
